import { useContext } from 'react';
import { ConfigurationListContext, ConfigurationListContextType } from '../configuration-list.context';

export const useConfigurationListContext = (): ConfigurationListContextType => {
    const context = useContext(ConfigurationListContext);
    if (context === undefined) {
        throw new Error('useConfigurationListContext must be used within ConfigurationListProvider');
    }
    return context;
};
